import { ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { Header } from '@/bundle/Auth/ui/AuthHeading/styles';
import { COLORS } from '@/styles/colors';

type AuthHeadingType = {
  header: string;
  subHeader: ReactNode;
  children?: ReactNode;
};

export const AuthHeading = ({ header, subHeader, children }: AuthHeadingType) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      rowGap='8px'
      marginBottom='28px'
      mobile={{ marginBottom: '0' }}
      padding='0 16px'
    >
      <Header>{header}</Header>
      <Typography variant='subTitleSmall' color={COLORS.grey[650]} fontWeight='medium' textAlign='center'>
        {subHeader}
      </Typography>
      {children}
    </Box>
  );
};
